import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingEmailTemplate } from '../booking-email-template';
import { CKEDITOREMAILCONFIG } from '../ckeditor-config';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';
import * as Editor from '../../libs/ckeditor';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-edit-booking-email-template',
  templateUrl: './edit-booking-email-template.component.html',
  styleUrls: ['./edit-booking-email-template.component.css']
})
export class EditBookingEmailTemplateComponent implements OnInit {

  selectedTemplate!: BookingEmailTemplate;
  templateForm!: FormGroup;
  processing = false;
  emailEditorConfig = CKEDITOREMAILCONFIG; 
  public Editor = Editor;
  colors: string[] = environment.backgroundColors;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let templateId = this.route.snapshot.paramMap.get("templateId");
    this.httpService.getBookingEmailTemplateById(Number(templateId)).subscribe(res => {
      this.selectedTemplate = res;
      this.templateForm = this.builder.group({
        name: [this.selectedTemplate.name, Validators.required],
        body: [this.selectedTemplate.body, Validators.required],
        language: [this.selectedTemplate.language, Validators.required],
        subject: [this.selectedTemplate.subject, Validators.required],
        backgroundColor: this.selectedTemplate.backgroundColor
    });
    });
  }

  updateBackgroundColor(value: string | null){
    this.templateForm.get("backgroundColor")?.setValue(value);
  }


  updateTemplate(){
    if(this.templateForm.invalid){
      this.toastService.addError("Error", "Please complete the form");
      return;
    }
    this.selectedTemplate.name = this.templateForm.value.name;
    this.selectedTemplate.body = this.templateForm.value.body;
    this.selectedTemplate.subject = this.templateForm.value.subject;
    this.selectedTemplate.backgroundColor = this.templateForm.value.backgroundColor;
    this.processing = true;
    this.httpService.updateBookingEmailTemplate(this.selectedTemplate).subscribe(() => {
      this.toastService.addSuccess("Success", "Updated successfully");
      this.processing = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.processing = false;
    });
  }

  deleteTemplate(){
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete this record?",
      accept: () => {
        this.httpService.deleteBookingEmailTemplate(this.selectedTemplate.id!).subscribe(() => {
          this.router.navigateByUrl("/management/booking-email-templates");
        });
      }
    });
  }

}
